import type { GatewayFilter } from '@/gateways/types';

export const graphqlOperatorMap = {
  eq: '_eq',
  ne: '_neq',
  like: '_like',
  notLike: '_nlike',
  in: '_in',
  notIn: '_nin',
  lt: '_lt',
  lte: '_lte',
  gt: '_gt',
  gte: '_gte',
} as const satisfies Record<GatewayFilter['operator'], string>;
